import { TOAST_VARIANT_SUCCESS, toastShow } from 'mailup-web-components'

import { STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'

import getIntl from 'Helpers/intl'

import type {
  ModalBulkAddToGroupState,
  SearchFiltersState,
  SelectionState,
} from 'Pages/RecipientsList/model'

import {
  beRecipientCopyMoveRecipientsToGroupByCustomSearch,
  beRecipientCopyMoveRecipientsToGroupByManualSelection,
  beRecipientGetGroupDetails,
  beRecipientUpdateGroup,
} from 'Api/beRecipientApi'

import {
  searchFiltersToConditions,
  toSubscriptionStatus,
} from 'Pages/RecipientsList/recoil/services/results'

export const notifyBulkAddToGroup = (move: boolean): void => {
  toastShow(
    getIntl().formatMessage({
      id: move
        ? 'Load.RecipientsList.BulkMoveToGroupSuccess'
        : 'Load.RecipientsList.BulkAddToGroupSuccess',
    }),
    TOAST_VARIANT_SUCCESS,
  )
}

export const addToGroup = async (
  {
    mode,
    checked,
    searchFilters,
  }: {
    mode: SelectionState['mode']
    checked: SelectionState['checked']
    searchFilters: SearchFiltersState
  },
  {
    addToGroupId,
    optRemoveFromGroups,
    removeFromGroupsMode,
    optMoveRandom,
    moveRandomAmount,
    optSetAsTestGroup,
    searchGroups,
  }: Pick<
    ModalBulkAddToGroupState,
    | 'addToGroupId'
    | 'optRemoveFromGroups'
    | 'removeFromGroupsMode'
    | 'optMoveRandom'
    | 'moveRandomAmount'
    | 'optSetAsTestGroup'
    | 'searchGroups'
  >,
): Promise<any> => {
  if (mode === 'selection' && checked.length === 0) {
    return
  }

  if (addToGroupId !== undefined) {
    const idList = storeGet(STORE_KEY_ID_LIST)

    const moveRandomN = moveRandomAmount !== undefined ? moveRandomAmount : 0

    if (mode === 'selection' && checked.length > 0) {
      await beRecipientCopyMoveRecipientsToGroupByManualSelection(
        idList,
        addToGroupId,
        checked,
        optRemoveFromGroups,
        optMoveRandom,
        moveRandomN,
        removeFromGroupsMode === 'all' ? [] : searchGroups,
      )
    } else {
      await beRecipientCopyMoveRecipientsToGroupByCustomSearch(
        idList,
        addToGroupId,
        {
          Conditions: searchFiltersToConditions(searchFilters),
          SubscriptionStatus: toSubscriptionStatus(searchFilters.status.value),
          MoveRecipients: optRemoveFromGroups,
          RandomSelectRecipients: optMoveRandom,
          RecipientToSelectRandom: moveRandomN,
          MoveFromGroups: removeFromGroupsMode === 'all' ? [] : searchGroups,
        },
      )
    }

    if (optSetAsTestGroup) {
      const { Id, ...groupDetails } =
        await beRecipientGetGroupDetails(addToGroupId)

      await beRecipientUpdateGroup(Id, {
        ...groupDetails,
        Type: 'Test',
      })
    }
  }
}
